import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import HeroSearch from '../components/HeroSearch';
import Benefits from '../components/Benefits';
import BannerCarousel from '../components/BannerCarousel';
import Bestsellers from '../components/Bestsellers';
import ThemesSection from '../components/ThemesSection';
import DestinationGrid from '../components/DestinationGrid';
import IndiaTourPackages from '../components/IndiaTourPackages';
import Partners from '../components/Partners';
import WhyUs from '../components/WhyUs';
import Testimonials from '../components/Testimonials';
import BlogPreview from '../components/BlogPreview';
import Footer from '../components/Footer';
import { trendingCountries, trendingStates } from '../mock';
import { useSettings } from '../store';
import { API } from '../api';
import { applyPageSEO } from '../utils/pageSEO';

const INDIA_SLUGS = new Set(['sikkim', 'kashmir', 'ladakh', 'himachal', 'goa', 'kerala', 'rajasthan', 'andaman', 'uttarakhand', 'meghalaya', 'darjeeling']);

const Home = () => {
  const settings = useSettings();
  const [countries, setCountries] = useState(trendingCountries);
  const [states, setStates] = useState(trendingStates);

  // Apply global SEO defaults (title/description/robots) to the homepage.
  useEffect(() => {
    return applyPageSEO({
      title: settings.seo_title || 'Explore, Discover, Enjoy',
      description: settings.seo_description || 'Travelsera — journeys, redefined. Explore handcrafted holiday packages across India and the world.',
      noIndex: !!settings.seo_no_index,
      noFollow: !!settings.seo_no_follow,
    });
  }, [settings.seo_title, settings.seo_description, settings.seo_no_index, settings.seo_no_follow]);

  useEffect(() => {
    axios.get(`${API}/taxonomies?type=destination`).then((res) => {
      const list = Array.isArray(res.data) ? res.data : [];
      if (list.length === 0) return;
      const mapped = list.map((t) => ({
        slug: t.slug,
        name: t.name,
        image: t.image || '',
        fbType: t.fb_type || 'default',
      }));
      const intl = mapped.filter((x) => !INDIA_SLUGS.has((x.slug || '').toLowerCase()));
      const india = mapped.filter((x) => INDIA_SLUGS.has((x.slug || '').toLowerCase()));
      if (intl.length > 0) setCountries(intl);
      if (india.length > 0) setStates(india);
    }).catch(() => {});
  }, []);

  return (
    <>
      <Header />
      <HeroSearch />
      <Benefits />
      <BannerCarousel />
      <Bestsellers />
      <ThemesSection />
      <DestinationGrid title={settings.section_countries_title || 'Top Trending Countries'} items={countries} />
      <DestinationGrid title={settings.section_states_title || 'Trending Indian States'} items={states} />
      <IndiaTourPackages />
      <Testimonials />
      <BlogPreview />
      <Partners />
      <WhyUs />
      <Footer />
    </>
  );
};

export default Home;
